<section class="select-country" [class]="customClasses">

  <div class="dropdown-toggle" data-toggle="dropdown" [class]="dropdownStyles">
    <span class="selected" [id]="idPrefix + '-country-select-selected'">
      <img *ngIf="country" class="flag" [src]="country?.flagUrl" [alt]="country?.id"> +{{country?.prefix}}
      <app-spinner [isLoading]="!country" [small]="true"></app-spinner>
    </span>
  </div>

  <ul class="options dropdown-menu" [ngClass]="{'numLoginFrom': isBanner}" [id]="idPrefix + '-country-select-options'">
    <li *ngFor="let country of countries"
        [id]="idPrefix + '-country-select-' + country.id"
        class="dropdown-item"
        (click)="sendSelectedCountry(country)">
        <img class="flag" [src]="country?.flagUrl" [alt]="country?.id"> +{{country?.prefix}}
    </li>
  </ul>

</section>

